// extracted by mini-css-extract-plugin
export var menu = "HoverMenu-module--menu--13ead";